module.exports = __webpack_public_path__ + "img/c_bg1.7ec4ac15.jpg";